import React from "react"
import { Link } from "react-router-dom"

export default function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg">
      <Link className="navbar-brand" to="/">
        MWX Apps
      </Link>
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="toggler-icon" />
        <span className="toggler-icon" />
        <span className="toggler-icon" />
      </button>
      <div
        className="collapse navbar-collapse sub-menu-bar"
        id="navbarSupportedContent"
      >
        <ul className="navbar-nav ml-auto">
          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdownApps"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Apps
            </a>
            <div className="dropdown-menu rich-dropdown dropdown-menu-right" aria-labelledby="navbarDropdownApps">
              <Link className="dropdown-item rich-menu-item" to="/faceit-pro-league">
                <div className="menu-icon">
                  <img src="/assets/images/2.png" alt="FPL" />
                </div>
                <div className="menu-content">
                  <span className="menu-title">FPL CS:GO & Faceit Stats</span>
                  <span className="menu-desc">Stats & Rankings</span>
                </div>
              </Link>
              <Link className="dropdown-item rich-menu-item" to="/fastris">
                <div className="menu-icon">
                  <img src="/assets/images/fastris.png" alt="FastRIS" />
                </div>
                <div className="menu-content">
                  <span className="menu-title">FastRIS</span>
                  <span className="menu-desc">Reverse Image Search</span>
                </div>
              </Link>
              <Link className="dropdown-item rich-menu-item" to="/ai-image-detection">
                <div className="menu-icon">
                  <img src="/assets/images/ai-detector.png" alt="AI Detector" />
                </div>
                <div className="menu-content">
                  <span className="menu-title">AI Image Detector</span>
                  <span className="menu-desc">Detect AI Content</span>
                </div>
              </Link>
              <Link className="dropdown-item rich-menu-item" to="/c2pa-ai-detector">
                <div className="menu-icon">
                  <img src="/assets/images/c2pa-detect.png" alt="C2PA AI Detector" />
                </div>
                <div className="menu-content">
                  <span className="menu-title">C2PA AI Detector</span>
                  <span className="menu-desc">Content Credentials & Origin</span>
                </div>
              </Link>
              <Link className="dropdown-item rich-menu-item" to="/image-search">
                <div className="menu-icon">
                  <img src="/assets/images/im_app.png" alt="Image Search" />
                </div>
                <div className="menu-content">
                  <span className="menu-title">Image Search</span>
                  <span className="menu-desc">Find & Share Images</span>
                </div>
              </Link>
              <Link className="dropdown-item rich-menu-item" to="/fastingsense">
                <div className="menu-icon">
                  <img src="/assets/images/fastingSense.png" alt="FastingSense" />
                </div>
                <div className="menu-content">
                  <span className="menu-title">FastingSense</span>
                  <span className="menu-desc">Fasting Tracker & Health Coach</span>
                </div>
              </Link>
              <Link className="dropdown-item rich-menu-item" to="/clashtrophy">
                <div className="menu-icon">
                  <img src="/assets/images/clashtropy.jpg" alt="ClashTrophy" style={{ borderRadius: "6px" }} />
                </div>
                <div className="menu-content">
                  <span className="menu-title">ClashTrophy</span>
                  <span className="menu-desc">Clash Royale Stats & Decks</span>
                </div>
              </Link>
              <Link className="dropdown-item rich-menu-item" to="/jobyne">
                <div className="menu-icon">
                  <img src="/assets/images/jobyne.png" alt="Jobyne" style={{ borderRadius: "6px" }} />
                </div>
                <div className="menu-content">
                  <span className="menu-title">Jobyne</span>
                  <span className="menu-desc">US Job Search</span>
                </div>
              </Link>
              <Link className="dropdown-item rich-menu-item" to="/AiSmartGallery">
                <div className="menu-icon">
                  <img src="/assets/images/AiSmartGallery.png" alt="AI Smart Gallery" style={{ borderRadius: "6px" }} />
                </div>
                <div className="menu-content">
                  <span className="menu-title">AI Smart Gallery</span>
                  <span className="menu-desc">Photo Search &amp; On-Device AI</span>
                </div>
              </Link>
              <Link className="dropdown-item rich-menu-item" to="/kolay-yemek-tarifleri">
                <div className="menu-icon">
                  <img src="/assets/images/1.png" alt="Yemek Tarifleri" />
                </div>
                <div className="menu-content">
                  <span className="menu-title">Kolay Yemek Tariflerim</span>
                  <span className="menu-desc">Lezzetli Tarifler</span>
                </div>
              </Link>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  )
}
